import React from 'react';

export default function EmptyHeader(): React.ReactNode {
  return null;
}
